import { OptimizelyContext, useDecision } from '@optimizely/react-sdk';
import { useContext } from 'react';

import optimizely from '.';
import { Flags } from './types';

export const useFeatureExperiment = (flagKey: Flags, eligibleForExperiment = true) => {
  const ctx = useContext(OptimizelyContext);
  const [decision] = useDecision(flagKey, undefined, {
    overrideAttributes: {
      ...ctx.optimizely?.user.attributes,
      eligible_for_experiment: eligibleForExperiment,
    },
  });

  return decision;
};

export const getFeatureExperiment = (
  flagKey: Flags,
  eligibleForExperiment = true,
  otherAttributes = {}
) => {
  const decision = optimizely.decide(flagKey, undefined, undefined, {
    ...optimizely.user.attributes,
    eligible_for_experiment: eligibleForExperiment,
    ...otherAttributes,
  });

  return decision;
};
